var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6558 16.0911H7.6703C6.29198 16.0911 5.11725 15.6441 4.14611 14.7501C3.17432 13.8566 2.68842 12.7759 2.68842 11.5078C2.68842 10.2398 3.17432 9.1587 4.14611 8.26464C5.11725 7.3712 6.29198 6.92448 7.6703 6.92448H11.6558V8.75781H7.6703C6.83999 8.75781 6.13422 9.02517 5.553 9.55989C4.97178 10.0946 4.68117 10.7439 4.68117 11.5078C4.68117 12.2717 4.97178 12.921 5.553 13.4557C6.13422 13.9904 6.83999 14.2578 7.6703 14.2578H11.6558V16.0911ZM8.66668 12.4245V10.5911H16.6377V12.4245H8.66668ZM13.6486 16.0911V14.2578H17.6341C18.4644 14.2578 19.1701 13.9904 19.7514 13.4557C20.3326 12.921 20.6232 12.2717 20.6232 11.5078C20.6232 10.7439 20.3326 10.0946 19.7514 9.55989C19.1701 9.02517 18.4644 8.75781 17.6341 8.75781H13.6486V6.92448H17.6341C19.0124 6.92448 20.1875 7.3712 21.1592 8.26464C22.1304 9.1587 22.616 10.2398 22.616 11.5078C22.616 12.7759 22.1304 13.8566 21.1592 14.7501C20.1875 15.6441 19.0124 16.0911 17.6341 16.0911H13.6486Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.586a844a1ac9579dce4e0ceb977733f4.svg";
export { ForwardRef as ReactComponent };